// extracted by mini-css-extract-plugin
export default {"selectedItem":"zAhzy","itemblock":"rs41O","close":"jyaLt","body":"njIbW","title":"MwzPd","accountBlock":"qkgVo","control":"N_pto","regionradio":"kHbBy","lastitem":"O13zW"};